import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AUTH_REQUIRED } from '@app/tokens';
import { UrlService } from '@services/url.service';
import { ISupportRequest } from '@shared/models/support-request.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SupportRequestsService {
  constructor(
    private httpClient: HttpClient,
    private urlService: UrlService,
  ) {}

  submitRequest(request: Partial<ISupportRequest>, authRequired: boolean = true): Observable<string> {
    const url = authRequired ? this.urlService.SUPPORT_REQUESTS_URL : this.urlService.SUPPORT_REQUESTS_NO_AUTH_URL;
    return this.httpClient.put<string>(url, request, {
      context: new HttpContext().set(AUTH_REQUIRED, authRequired),
    });
  }

  getHelpTopics() {
    const helpTopics = [];
    helpTopics.push('How do I dispute an insurance response?');
    helpTopics.push('How do I use a coupon instead of consignment?');
    helpTopics.push('Missing or cancel consignment ID');
    helpTopics.push('The site is not working properly');
    helpTopics.push('How do I add a user to my pharmacy?');
    helpTopics.push('I need to reset my password');
    helpTopics.push('Other feedback');

    return helpTopics;
  }
}
